import { loc } from "../../../../../core/utils"
import { string } from "prop-types"
import { node } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function Upfront({ upfrontPrice, oldPrice, children }) {
  return (
    <li>
      <Row>
        <Col>
          <p>{loc`Upfront`}</p>
          {children?.[0]}
          {children?.[1]}
        </Col>
        <Col>
          {oldPrice ? (
            <div className="tradein-price-container">
              <div className="tradein-old-price text-right">
                <s className="strike">{oldPrice}</s>
              </div>
              <div className="tradein-new-price text-right">
                {upfrontPrice}
                {children?.[2]}
              </div>
            </div>
          ) : (
            <p className="text-right">
              {upfrontPrice}
              {children?.[2]}
            </p>
          )}
        </Col>
      </Row>
    </li>
  )
}

Upfront.propTypes = {
  children: node,
  upfrontPrice: string,
  oldPrice: string
}
